import styles from "./SearchModal.module.scss";
import Banner2 from "@/public/assets/contents/banner2.png";
import LeftIcon from "@/public/assets/ic_back_arrow.svg";
import SearchIcon from "@/public/assets/ic-search.svg";
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import MostReadCard from "../most-read-card/MostReadCard";
import {
  Box,
  CircularProgress,
  Dialog,
  Stack,
  useMediaQuery,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { blogListRedux } from "@/app/store/blog-list/reducers";
import { DateFormatter } from "@/utils/DateFormatter";
import { useRouter } from "next/router";
import Constants from "@/utils/constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CategoryCard = (props) => {
  return (
    <p
      onClick={props.onClick}
      className={`${
        props?.isSelected ? styles.selectedCard : styles.unselectedCard
      }`}
    >
      {props?.title}
    </p>
  );
};

const BlogsSearchModal = (props) => {
  const isSmallScreen = useMediaQuery("(max-width: 767px)");
  const isLandScape = useMediaQuery("(max-height: 450px)");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [debouncedSearchKey, setDebouncedSearchKey] = useState("");
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const handleIconClick = () => {
    inputRef.current?.focus();
  };

  const blogsListByCategory = useSelector(
    (state) => state?.blogList?.blogListByCategory
  );

  const searchBlogs = (data) =>
    dispatch(blogListRedux.actions.getBlogSearchListRequest(data));

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchKey(searchKey);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchKey]);

  useEffect(() => {
    searchBlogs({
      searchKey: debouncedSearchKey?.trim(),
      categoryName: selectedCategory,
    });
  }, [debouncedSearchKey, selectedCategory]);

  const searchBlogList = useSelector(
    (state) => state?.blogList?.searchBlogList?.blogs
  );

  const isSearchBlogLoading = useSelector(
    (state) => state?.blogList?.isSearchBlogListLoading
  );

  const router = useRouter();

  const handleNavigateToDetails = (slug) => {
    router.push(`/${slug}`);
    props?.onClose();
  };

  return (
    <Dialog
      fullScreen={isSmallScreen || isLandScape}
      fullWidth={true}
      maxWidth={isSmallScreen || isLandScape ? "lg" : false}
      open={props?.open}
      TransitionComponent={Transition}
      onClose={props?.onClose}
      PaperProps={{
        style: {
          background: "transparent",
          boxShadow: "none",
          width: isSmallScreen || isLandScape ? "100%" : "980px",
          height: isSmallScreen || isLandScape ? "100%" : "758px",
          borderRadius: isSmallScreen || isLandScape ? "0" : "48px",
        },
      }}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(10px)",
          backgroundColor: "#242424D1",
        },
      }}
    >
      <div className={styles.modalContent}>
        <div className={styles.backBtn}>
          <Image
            onClick={props?.onClose}
            src={LeftIcon.src}
            alt={"back"}
            width={30}
            height={30}
          />
        </div>
        <div className={styles.searchInputWrapper}>
          <Image
            width={25}
            height={30}
            src={SearchIcon.src}
            alt={"Search Icon"}
            onClick={handleIconClick}
          />
          <input
            ref={inputRef}
            placeholder="Search here"
            value={searchKey}
            onChange={(e) => {
              if (e.target.value?.length <= Constants.InputCharacterLimit) {
                setSearchKey(e.target.value);
              }
            }}
          />
        </div>

        <div className={styles.searchContents}>
          {blogsListByCategory ? (
            <div className={styles.categoriesWrapper}>
              {blogsListByCategory?.map((category, index) => (
                <CategoryCard
                  key={index}
                  title={category?.name}
                  isSelected={category?.name === selectedCategory}
                  onClick={() =>
                    setSelectedCategory((prev) =>
                      prev === category?.name ? "" : category?.name
                    )
                  }
                />
              ))}
            </div>
          ) : null}

          <div className={styles.mostReadCardSection}>
            {isSearchBlogLoading ? (
              <Stack mt={5} direction={"row"} justifyContent={"center"}>
                <CircularProgress sx={{ color: "#939393" }} />
              </Stack>
            ) : (
              <Box pb={isLandScape ? "290px" : 6}>
                {searchBlogList?.length ? <p>Most Read</p> : ""}

                {searchBlogList?.length ? (
                  searchBlogList?.map((blog, index) => (
                    <MostReadCard
                      key={index}
                      cardType={"search"}
                      image={blog?.media?.url}
                      researchDetails={
                        !!blog?.author?.name &&
                        blog?.publishedAt &&
                        `${blog?.author?.name} ${
                          blog?.publishedAt &&
                          ` / ${DateFormatter(blog?.publishedAt)}`
                        }`
                      }
                      title={blog?.title}
                      description={blog?.short_description}
                      onClick={() => handleNavigateToDetails(blog?.slug)}
                    />
                  ))
                ) : (
                  <Stack mt={5} direction={"row"} justifyContent={"center"}>
                    <p style={{ textAlign: "center" }}>No Data</p>
                  </Stack>
                )}
              </Box>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default BlogsSearchModal;
